import React, { useState, useEffect } from "react";
import {
  Col, Card, CardBody, Form, Input, Button, Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMissingAppRequest,
  updateMissingAppRequest,
  searchMissingAppRequest,
  UPDATE_LOCAL_MISSING_APP,
  fetchResolveAndUnResolveRequest
} from "../../../store/iOS/iOSmissingApp/missingAppAction";
import PageSection from '../../../components/Loader/loader';

const AllBetaEmails = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [editableRow, setEditableRow] = useState(null);
  const [editedUrlScheme, setEditedUrlScheme] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(30);
  const [fetchedEntries, setFetchedEntries] = useState([]);
  const [totalFetchedCount, setTotalFetchedCount] = useState(0);
  const [displayedItems, setDisplayedItems] = useState([]);
  const [noResultsFound, setNoResultsFound] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [highlightedRow, setHighlightedRow] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const location = useLocation();
  const { appId } = location.state || {};
  const [foundStatus, setFoundStatus] = useState("Working");

  const dispatch = useDispatch();
  const { missingAppData, resolveUnrResolve, searchResults = [], loading } = useSelector((state) => state.missingApp);

  useEffect(() => {
    if (appId) {
      setHighlightedRow(appId);
    }
  }, [appId]);

  useEffect(() => {
    if (!missingAppData || missingAppData.length === 0) {
      dispatch(fetchMissingAppRequest(1, 120));
      dispatch(fetchResolveAndUnResolveRequest()
      )
    } else {
      setDisplayedItems(missingAppData);
    }
  }, [dispatch, missingAppData]);

  // Search effect
  useEffect(() => {
    const handleSearch = () => {
      if (searchTerm.length >= 3) {
        setSearchLoading(true);
        dispatch(searchMissingAppRequest(searchTerm));
      } else {
        setDisplayedItems(missingAppData);
        setNoResultsFound(false);
      }
    };

    const timeoutId = setTimeout(handleSearch, 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTerm, dispatch, missingAppData]);

  useEffect(() => {
    if (searchTerm.length >= 3) {
      setSearchLoading(false);
      if (searchResults.length > 0) {
        setDisplayedItems(searchResults);
        setNoResultsFound(false);
      } else {
        setNoResultsFound(true);
        const clearItemsTimeout = setTimeout(() => {
          setDisplayedItems([]);
        }, 500);

        return () => clearTimeout(clearItemsTimeout);
      }
    } else {
      setDisplayedItems(missingAppData);
      setNoResultsFound(false);
    }
  }, [searchResults, searchTerm, missingAppData]);

  useEffect(() => {
    if (currentPage % 4 === 0 && totalFetchedCount <= currentPage * itemsPerPage) {
      const nextPage = currentPage / 4 + 1;
      dispatch(fetchMissingAppRequest(nextPage, 120));
    }
  }, [currentPage, dispatch, totalFetchedCount]);

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);

    if (filter === "All") {
      setDisplayedItems(missingAppData);
    } else if (filter === "resolve") {
      const resolvedItems = resolveUnrResolve.resolveCount.rows || [];
      setDisplayedItems(resolvedItems);
    } else if (filter === "unresolve") {
      const unresolvedItems = resolveUnrResolve.notResolveCount.rows || [];
      setDisplayedItems(unresolvedItems);
    }
  };


  const totalPages = Math.ceil(displayedItems.length / itemsPerPage);
  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const displayedPaginationItems = displayedItems.slice(indexOfFirstItem, indexOfFirstItem + itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    let startPage, endPage;

    if (totalPages <= 3) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 2) {
        startPage = 1;
        endPage = 3;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 2;
        endPage = totalPages;
      } else {
        startPage = currentPage - 1;
        endPage = currentPage + 1;
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${i === currentPage ? "active" : ""}`}
        >
          <Link to="#" className="page-link" onClick={() => paginate(i)}>
            {i}
          </Link>
        </li>
      );
    }

    return pageNumbers;
  };

  const handleEdit = (row) => {
    setEditableRow(row.appId);
    setEditedUrlScheme(row.urlScheme);
  };

  const handleSave = (appId) => {
    if (foundStatus[appId] === "Found" && !editedUrlScheme) {
      toast.error("URL Scheme cannot be empty");
      return;
    }

    const updatedData = {
      appId,
      urlScheme: editedUrlScheme || null,
      foundStatus: foundStatus[appId] || "",
      isResolve: foundStatus[appId] === "Found",
      isEmailSent: foundStatus[appId] === "Found",
    };

    dispatch({
      type: UPDATE_LOCAL_MISSING_APP,
      payload: updatedData,
    });

    dispatch(updateMissingAppRequest(updatedData));

    setDisplayedItems((prevItems) =>
      prevItems.map((item) =>
        item.appId === appId
          ? {
            ...item,
            foundStatus: foundStatus[appId] || "",
            urlScheme: editedUrlScheme,
            isEmailSent: foundStatus[appId] === "Found",
            isResolve: foundStatus[appId] === "Found",
          }
          : item
      )
    );

    toast.success("Updated Successfuly. ");
    resetEditingState();
  };


  const handleCancel = () => {
    resetEditingState();
  };

  const resetEditingState = () => {
    setEditableRow(null);
    setEditedUrlScheme("");
  };

  const handleFoundStatusChange = (appId, status) => {
    setFoundStatus((prevStatus) => ({
      ...prevStatus,
      [appId]: status,
    }));
  };
  // Helper function to extract region from appUrl
  const getRegionFromUrl = (url) => {
    const match = url.match(/apple\.com\/([a-z]{2})\//i);
    return match ? match[1].toUpperCase() : "UNKNOWN"; // Default to UNKNOWN if region is not found
  };


  return (
    <React.Fragment>
      <Toaster />
      <Col lg={12}>
        <Card>
          <div className="mb-4 text-center">
          </div>
          <div className="row justify-content-center px-3">
            <div className="col-4">
              <div className="card p-4 text-center" style={{
                borderRadius: '12px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.2s',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <h5 className="mb-3" style={{ color: '#17a2b8' }}>Total Apps</h5>
                <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#495057' }}>
                  {resolveUnrResolve.totalCount}
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="card p-4 text-center" style={{
                borderRadius: '12px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.2s',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <h5 className="mb-3" style={{ color: '#28a745' }}>Resolved Apps</h5>
                <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#495057' }}>
                  {resolveUnrResolve.resolveCount?.count}
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="card p-4 text-center" style={{
                borderRadius: '12px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.2s',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <h5 className="mb-3" style={{ color: '#dc3545' }}>Unresolved Apps</h5>
                <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#495057' }}>
                  {resolveUnrResolve.notResolveCount?.count}
                </div>
              </div>
            </div>
          </div>
        </Card>
        <Card style={{ paddingBottom: "55px" }}>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center ">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="card-title mt-1">iOS Missing Apps</h4>
              </div>
              <div className="d-flex align-items-center ">
                <Form className="app-search d-none d-lg-block pt-2 mt-2" onSubmit={(e) => e.preventDefault()}>
                  <div className="position-relative">
                    <Input
                      type="text"
                      className="form-control"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      placeholder="Search"
                    />
                    <span className="ri-search-line"></span>
                  </div>
                </Form>
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="ms-2">
                  <DropdownToggle caret>
                    {selectedFilter === "All" ? "All" : selectedFilter.charAt(0).toUpperCase() + selectedFilter.slice(1)}
                  </DropdownToggle>

                  <DropdownMenu>
                    <DropdownItem onClick={() => handleFilterChange("All")}>All</DropdownItem>
                    <DropdownItem onClick={() => handleFilterChange("resolve")}>Resolve</DropdownItem>
                    <DropdownItem onClick={() => handleFilterChange("unresolve")}>Unresolve</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>

            </div>

            {loading || searchLoading ? (
              <div className="table-responsive p-2" style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50%"
              }}>
                <PageSection />
              </div>
            ) : (
              <div className="table-responsive">
                <table
                  className="table table-bordered"
                  style={{ minWidth: "max-content" }}
                >
                  <thead>
                    <tr>
                      <th className="p-3">No.</th>
                      <th className="p-3">Image</th>
                      <th className="p-3">Email</th>
                      <th className="p-3">App ID</th>
                      <th className="p-3">App Name</th>
                      <th className="p-3">App Identifier</th>
                      <th className="p-3">URL Scheme</th>
                      <th className="p-3">App Type</th>
                      <th className="p-3">Region</th>
                      <th className="p-3">Status</th>
                      <th className="p-3">Found Status</th>
                      <th className="p-3">Notify Status</th>
                      <th className="p-3">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedPaginationItems.length === 0 ? (
                      <tr>
                        <td colSpan="12" className="text-center p-5">
                          {noResultsFound ? (
                            <div>No data found</div>
                          ) : (
                            <PageSection />
                          )}
                        </td>
                      </tr>
                    ) : (
                      displayedPaginationItems.map((row, index) => (
                        <tr
                        key={row.id}
                        className="align-middle"
                        style={{
                          backgroundColor: row.appId === highlightedRow ? "#e5f2ff" : "white",
                        }}
                      >
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td className="p-3">
                          <img
                            src={row.iconUrl}
                            alt=""
                            style={{ width: "50px", height: "50px", objectFit: "cover" }}
                          />
                        </td>
                        <td className="p-3">{row.email}</td>
                        <td className="p-3">{row.appId}</td>
                        <td className="p-3">{row.appName}</td>
                        <td className="p-3">{row.appIdentifier}</td>
                        <td>
                          {foundStatus[row.appId] === "Found" && editableRow === row.appId ? (
                            <Input
                              type="text"
                              value={editedUrlScheme}
                              onChange={(e) => setEditedUrlScheme(e.target.value)}
                            />
                          ) : (
                            row.urlScheme
                          )}
                        </td>
                        <td className="p-3">{row.appType}</td>
                        <td className="p-3">
                          {row.region ? row.region.toUpperCase() : getRegionFromUrl(row.appUrl)}
                        </td>
                        <td>
                          <span
                            className={`badge`}
                            style={{
                              backgroundColor: row.isResolve ? "#d4edda" : "#f8d7da",
                              color: row.isResolve ? "#155724" : "#721c24",
                              border: `1px solid ${row.isResolve ? "#c3e6cb" : "#f5c6cb"}`,
                              padding: "5px",
                              borderRadius: "5px",
                              fontSize: "12px",
                            }}
                          >
                            {row.isResolve ? "Resolved" : "Unresolved"}
                          </span>
                        </td>
                        <td>
                          {editableRow === row.appId ? (
                            <select
                              value={foundStatus[row.appId] || "Working"}
                              onChange={(e) => handleFoundStatusChange(row.appId, e.target.value)}
                            >
                              <option value="Working">Working</option>
                              <option value="Paid">Paid</option>
                              <option value="Not Found">Not Found</option>
                              <option value="Found">Found</option>
                            </select>
                          ) : typeof row.foundStatus === "string" ? (
                            row.foundStatus
                          ) : (
                            "Unknown"
                          )}
                        </td>
                        <td>
                          <span
                            className="d-flex align-items-center"
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              color: row.isEmailSent ? "#0c5460" : "#856404",
                            }}
                          >
                            <span
                              style={{
                                width: "8px",
                                height: "8px",
                                borderRadius: "50%",
                                backgroundColor: row.isEmailSent ? "#0c5460" : "#856404",
                                display: "inline-block",
                                marginRight: "8px",
                              }}
                            ></span>
                            {row.isEmailSent ? "Sent" : "Pending"}
                          </span>
                        </td>
                        <td>
                          {editableRow === row.appId ? (
                            <>
                              <Link
                                to="#"
                                className="me-3 text-success"
                                onClick={() => handleSave(row.appId)}
                              >
                                <i className="mdi mdi-check font-size-18"></i>
                              </Link>
                              <Link to="#" className="text-danger" onClick={handleCancel}>
                                <i className="mdi mdi-close font-size-18"></i>
                              </Link>
                            </>
                          ) : (
                            <Link
                              to="#"
                              className="me-3 text-primary"
                              onClick={() => handleEdit(row)}
                            >
                              <i className="mdi mdi-pencil font-size-18"></i>
                            </Link>
                          )}
                        </td>
                      </tr>
                      
                      ))
                    )}
                  </tbody>
                </table>
                <nav>
                  <ul
                    className="pagination justify-content-end"
                    style={{
                      position: "absolute",
                      marginTop: "15px",
                      right: "20px",
                    }}
                  >
                    <li
                      className={`page-item ${currentPage === 1 ? "disabled" : ""
                        }`}
                    >
                      <Link
                        to="#"
                        className="page-link"
                        onClick={() => paginate(currentPage - 1)}
                      >
                        &laquo;
                      </Link>
                    </li>
                    {renderPageNumbers()}
                    <li
                      className={`page-item ${currentPage === totalPages ? "disabled" : ""
                        }`}
                    >
                      <Link
                        to="#"
                        className="page-link"
                        onClick={() => paginate(currentPage + 1)}
                      >
                        &raquo;
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </CardBody>
        </Card>
      </Col>

    </React.Fragment>
  );
};

export default AllBetaEmails;
